import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import get from 'lodash/get'

/**
 * Determines whether the Room has a valid state
 * @param state The Redux state
 */

const getTwilioRoomState = (state: State): string => get(state.room, `room.state`, '')

export default createSelector(
  [getTwilioRoomState],
  (roomState) => {

    return roomState === 'connected'

  })
